import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { filterCommonAttributes } from './analytics-helpers';
import type { commonAttributesType } from './types';

export const onAIAnswerDialogQueryIntent: (props: commonAttributesType) => AnalyticsEventPayload = (
	props: commonAttributesType,
): AnalyticsEventPayload => {
	const { query, source } = props;
	return {
		action: 'surfaced',
		actionSubject: 'aiAnswerDialog',
		actionSubjectId: 'queryIntent',
		source: source,
		eventType: 'track',
		attributes: {
			...filterCommonAttributes(props),
		},
		nonPrivacySafeAttributes: {
			query,
		},
	};
};
